import { Box, BoxProps, Divider, makeStyles, Theme, Typography } from '@material-ui/core'
import clsx from 'clsx'
import { DataLoadSegment } from 'js/components'
import { useTaskSubscriber } from 'js/hooks'
import React from 'react'

interface Props extends BoxProps {
  headerAndCells: {
    header: string
    headerClass?: string
    cell: string | React.ReactNode
    cellClass?: string
  }[]
  loadname?: string[]
}

const CustomTable: React.FC<Props> = (props: Props) => {
  const classes = useStyles()
  const { headerAndCells, className, loadname = [], ...rest } = props
  const [loading] = useTaskSubscriber(...loadname)

  return (
    <Box
      {...rest}
      className={clsx(classes.root, className)}
    >
      <DataLoadSegment loading={loading} filter>
        {headerAndCells.map(
          (headerAndCell, index) => (
            <React.Fragment key={index}>
              <Box display='flex' paddingY={1.5}>
                <Typography variant='body1' className={clsx(classes.label, headerAndCell?.headerClass)}>
                  {headerAndCell.header}
                </Typography>
                <Typography variant='body1' className={clsx(classes.value, headerAndCell?.cellClass)}>
                  {headerAndCell.cell}
                </Typography>
              </Box>
              {index + 1 < headerAndCells.length && (<Divider />)}
            </React.Fragment>
          ),
        )}
      </DataLoadSegment>
    </Box>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    margin: '2rem 0',
    '& div:last-child': {
      border: 0,
    },
  },
  label: {
    width: '40%',
  },
  value: {
    width: '60%',
    textAlign: 'left',
  },
}))

export default CustomTable
